import React from 'react';
import {FormBuilder} from "../../components/Form/FormBuilder/FormBuilder.jsx";
import {Paper, CircularProgress, Alert, Button, Typography, Box, Stack} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const TopicForm = ({
                       // Form data and state (received from parent)
                       formData,
                       formLoading,
                       formError,
                       needsFormCreation,
                       isAutoCreating,
                       // Form methods (received from parent)
                       onCreateForm,
                       onSaveForm,
                       // For AI Chat integration (received from parent)
                       onUpdateFormData,
                       onRefreshFormData,
                       // Topic status
                       isPublished = false,
                   }) => {

    const handleSave = async (formDataToSave) => {
        try {
            const result = await onSaveForm(formDataToSave);
            return result;
        } catch (err) {
            throw err; // Re-throw to let FormBuilder handle the error
        }
    };

    const handleCreateForm = async () => {
        try {
            await onCreateForm();
        } catch (err) {
            console.error('Failed to create form:', err);
        }
    };

    return (
        <Paper sx={{p: 3, position: 'relative'}} variant="outlined">
            {/* Warning when topic is published */}
            {isPublished && (
                <Alert
                    severity="info"
                    icon={<InfoIcon />}
                    sx={{mb: 2}}
                >
                    <Stack spacing={0.5}>
                        <Typography variant="body2" fontWeight="bold">
                            This topic is currently published
                        </Typography>
                        <Typography variant="body2">
                            Questions cannot be edited while the topic is published. Please unpublish the topic to make changes.
                        </Typography>
                    </Stack>
                </Alert>
            )}

            {formLoading ? (
                <Box sx={{textAlign: 'center', padding: '2rem'}}>
                    <CircularProgress/>
                    <Typography variant="body2" sx={{mt: 2}}>
                        {isAutoCreating ? 'Creating form automatically...' : 'Loading form...'}
                    </Typography>
                </Box>
            ) : formError ? (
                <Alert severity="error">{formError}</Alert>
            ) : needsFormCreation ? (
                <Box sx={{textAlign: 'center', padding: '2rem'}}>
                    <Typography variant="body1" sx={{mb: 2}}>
                        No form exists for this topic yet.
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
                        Create a form to start adding questions and content for this topic.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCreateForm}
                        size="large"
                        disabled={isPublished}
                    >
                        Create Topic Form
                    </Button>
                    {isPublished && (
                        <Typography variant="caption" color="text.secondary" display="block" sx={{mt: 1}}>
                            Unpublish the topic to create a form
                        </Typography>
                    )}
                </Box>
            ) : (
                <FormBuilder
                    initialData={formData}
                    onSave={handleSave}
                    key={formData.length > 0 ? formData[0]?.id : 'empty-form'}
                    canToggleEdit={!isPublished}
                    editable={false}
                />
            )}
        </Paper>
    );
};

export default TopicForm;